import { createContext, useEffect, useState } from "react";
import { DISPLAY_LANG } from "../config";
import axios from '../axios';

export const CurrencyContext = createContext();

export default function CurrencyProvider({ children }) {
    const [currencyList, setCurrencyList] = useState([]);

    // const currencyList = [
    //     { id: 1, title: 'USD', code: 'en', symbol: '$' },
    //     { id: 2, title: 'EUR', code: null, symbol: '€' },
    //     { id: 3, title: 'RUB', code: 'ru', symbol: '₽' },
    //     { id: 4, title: 'AMD', code: 'am', symbol: '֏' },
    // ];

    const [selectedCurrency, setSelectedCurrency] = useState(null);

    useEffect(() => {
        axios.get('global/currency_list').then(res => setCurrencyList(res.data));
    }, [])

    useEffect(() => {
        const currentCurrencyList = currencyList.find(c => c.code === DISPLAY_LANG);
        setSelectedCurrency(currentCurrencyList);
    }, [currencyList]);

    return (
        <CurrencyContext.Provider value={{ currencyList, selectedCurrency, setSelectedCurrency }}>
            {children}
        </CurrencyContext.Provider>
    );
}